<template>
  <div class="inline-block">
    <button
      ref="triggerButton"
      class="p-2 rounded-full hover:bg-gray-100 focus:outline-none"
      @click="toggleMenu"
    >
      <slot name="trigger">
        <FontAwesomeIcon :icon="['fas', 'ellipsis-vertical']" />
      </slot>
    </button>

    <Teleport to="body">
      <Transition>
        <div
          v-if="isOpen"
          ref="menuContent"
          :style="positionStyles"
          class="z-50"
        >
          <div
            class="py-2 w-48 bg-white rounded-md shadow-xl border border-gray-200"
            @click="closeMenu"
          >
            <slot>
              <!-- Default slot for menu items -->
            </slot>
          </div>
        </div>
      </Transition>
    </Teleport>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { computePosition, offset, flip, shift } from '@floating-ui/dom';

export default {
  name: 'DropdownMenu',
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      isOpen: false,
      positionStyles: {
        position: 'absolute',
        top: '0',
        left: '0',
      },
    };
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.$nextTick(() => {
          this.updatePosition();
        });
      }
    },
    closeMenu() {
      this.isOpen = false;
    },
    handleClickOutside(e) {
      if (
        !this.$refs.triggerButton?.contains(e.target) &&
        !this.$refs.menuContent?.contains(e.target)
      ) {
        this.closeMenu();
      }
    },
    updatePosition() {
      if (!this.$refs.triggerButton || !this.$refs.menuContent) {
        return;
      }

      computePosition(this.$refs.triggerButton, this.$refs.menuContent, {
        placement: 'bottom-start',
        middleware: [offset(5), flip(), shift()],
      }).then(({ x, y }) => {
        this.positionStyles = {
          position: 'absolute',
          top: `${y}px`,
          left: `${x}px`,
        };
      });
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    // capture phase so scrolling any ancestor container, not just the page,
    // re-anchors the teleported menu to the trigger (same as MultiSelectDropdown)
    window.addEventListener('scroll', this.updatePosition, true);
    window.addEventListener('resize', this.updatePosition);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
    window.removeEventListener('scroll', this.updatePosition, true);
    window.removeEventListener('resize', this.updatePosition);
  },
};
</script>

<style>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.2s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
